import React, { useState, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import ApplePay from 'services/ApplePay';
import { Button, Image } from 'components/ui';

/**
 * Apple Pay Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Apple Pay logo
 */
const Apple = props => {
    const [isApplePayEnabled, setIsApplePayEnabled] = useState(true); // Default to true for pill button view

    useEffect(() => {
        if (props.orderDetails) {
            ApplePay.getApplePaymentType(props.orderDetails).then(_payType => {
                // For Release 4 pill button view, always show Apple Pay button FOR now so QA can confirm it shows.
                // TODO: Toggle visibility based on actual Apple Pay availability later.
                // The actual payment functionality will still check availability
                setIsApplePayEnabled(true);
            });
        } else {
            Sephora.logger.verbose('[SHP-2591] Apple Pay - No orderDetails, setting enabled for pill view');
            // Always show in pill button layout for new user view
            setIsApplePayEnabled(true);
        }
    }, [props.orderDetails]);

    const { handlePayWithApplePayClick } = props;

    Sephora.logger.verbose('[SHP-2591] Apple Pay - Rendering, isApplePayEnabled:', isApplePayEnabled);

    // Always show Apple Pay pill button in new user view
    // Actual payment flow will handle availability check

    return (
        <Button
            variant='primary'
            onClick={handlePayWithApplePayClick}
            data-at={Sephora.debug.dataAt('apple_pay_button')}
            aria-label='Pay with Apple Pay'
            css={styles}
            width={['151px', '151px', '182px']}
        >
            <Image
                src='/img/ufe/logo-apple-pay.svg'
                alt=''
                aria-hidden='true'
                height='24px'
            />
        </Button>
    );
};

const styles = {
    backgroundColor: '#000',
    borderRadius: '22px',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    gap: '12px',
    flexShrink: 0,
    '&:hover': {
        backgroundColor: '#333'
    }
};

export default wrapFunctionalComponent(Apple, 'Apple');
